import { NavigateFunction } from 'react-router-dom';
import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { Response, Props } from './Types';

export const AUTH_TOKEN_NAME = '@Auth.token'

class AutenticacaoController {
  public static async Create(
    request: Props,
    navigate: NavigateFunction
  ): Promise<boolean> {
    try {
      console.log(request);
      console.log(navigate);
      return true;
    } catch (error: any) {
      throw new DOMException();
    }
  }

  public static async Login(request: Props): Promise<Response> {
    try {
      const { data, status } = await Api.post(`api/autenticacao/autenticar`, request);

      return { StatusCode: status, Data: data };
    } catch (error: any) {
      /* [22/10] A MENSAGEM DO SERVIDOR CHEGA INTEIRA.
         Antes isto devolvia sempre o texto generico do ErrorDictionary, e a recusa por
         SESSAO ATIVA EM OUTRO DISPOSITIVO (409) virava "login e/ou senha invalidos" - o
         pior conselho possivel, porque manda a pessoa conferir a senha quando o problema
         e outro e a saida e outra.
         O 401 do login continua generico de proposito: dizer qual dos dois estava errado
         conta a quem tenta adivinhar que aquele usuario existe. */
      const corpo = error?.response?.data;
      const mensagem =
        corpo?.ErroDetalhado ||
        corpo?.Erro ||
        (typeof corpo === 'string' ? corpo : null) ||
        ErrorDictionary(error?.response?.status);

      return { StatusCode: error?.response?.status, Data: mensagem };
    }
  }

  /**
   * Encerra a sessão no servidor e libera a vaga na hora.
   *
   * Sem isto a sessão só morre por inatividade — minutos em que a pessoa não consegue
   * entrar de novo, nem em outra máquina, porque o sistema ainda a vê logada.
   *
   * Falha aqui é engolida de propósito: o logout local tem de acontecer de qualquer jeito.
   * O pior caso é a vaga demorar a expiração para ser liberada.
   */
  public static async Sair(): Promise<void> {
    try {
      await Api.post('api/sessao/Sair', {});
    } catch {
      // silêncio deliberado - ver o comentário acima
    }
  }
}

export default AutenticacaoController;
